<template>
  <v-menu v-model="menu" :close-on-content-click="false" offset-y min-width="auto">
    <template v-slot:activator="{ on, attrs }">
      <v-text-field :value="display" :label="label" readonly outlined dense hide-details="auto"
                    :clearable="clearable" :disabled="disabled" :rules="rules" :placeholder="placeholder"
                    prepend-inner-icon="mdi-calendar" v-bind="attrs" v-on="on" @click:clear="$emit('input', '')"/>
    </template>
    <v-date-picker :value="value" @input="pick" locale="de" first-day-of-week="1" no-title
                   :min="min" :max="max" :allowed-dates="allowedDates" show-week/>
  </v-menu>
</template>

<script>
import {fmtDay} from '@/shared/dienstplan_api'

// Date input (YYYY-MM-DD value, dd.MM.yyyy display) used by the Dienstplanung views.
export default {
  name: 'DpDateField',
  props: {
    value: {type: String, default: ''},
    label: {type: String, default: ''},
    min: {type: String, default: undefined},
    max: {type: String, default: undefined},
    clearable: {type: Boolean, default: false},
    disabled: {type: Boolean, default: false},
    placeholder: {type: String, default: ''},
    rules: {type: Array, default: () => []},
    allowedDates: {type: Function, default: null},
  },
  data: () => ({menu: false}),
  computed: {
    display () {
      return fmtDay(this.value)
    },
  },
  methods: {
    pick (v) {
      this.menu = false
      this.$emit('input', v)
    },
  },
}
</script>
